export const breakpoints = {
    xs: 375,
    sm: 640,
    md: 768,
    lg: 992,
    xl: 1280
}

export const screenSizes = {
    xs: `(max-width: ${breakpoints.xs}px)`, // 0–375
    sm: `(min-width: ${breakpoints.xs + 1}px) and (max-width: ${breakpoints.sm}px)`, // 376–640
    md: `(min-width: ${breakpoints.sm + 1}px) and (max-width: ${breakpoints.md}px)`, // 641–768
    lg: `(min-width: ${breakpoints.md + 1}px) and (max-width: ${breakpoints.xl}px)`, // 769–1280
    xl: `(min-width: ${breakpoints.xl + 1}px)` // 1281+
}

export const breakpointRanges = {
    xs: {min: 0, max: breakpoints.xs}, // 0–375
    sm: {min: breakpoints.xs + 1, max: breakpoints.sm}, // 376–640
    md: {min: breakpoints.sm + 1, max: breakpoints.md}, // 641–768
    lg: {min: breakpoints.md + 1, max: breakpoints.xl}, // 769–1280
    xl: {min: breakpoints.xl + 1} // 1281+
}
